export default __webpack_public_path__ + "static/media/planticon_8.5e93453d.png";